<div class="mt-24">
  <div class="grid grid--gap-32 grid--va-middle">
    <div class="grid__box grid__box--size-min">
      <span class="title title--s">Тип данных</span>
    </div>
    <div class="grid__box grid__box--size-min">
      <app-select [items]="types" (callback)="onChangeTypeSelected($event)" [textKey]="'name'" [initBy]="typeSelected" [name]="'EmployeeStatusName'"></app-select>
    </div>
  </div>
</div>
<div class="mt-32">
  <app-tickets-sync *ngIf="typeSelected && typeSelected.id === 1"></app-tickets-sync>
</div>
